import React from 'react';
import { Grid, Paper, Stack, Typography } from '@mui/material';
import { Form } from 'mobx-react-form';
import { observer } from 'mobx-react-lite';
import { wrapForm, FormOptions } from 'components/shared/form';
import { plugins } from 'forms/utils/formPlugins';
import { formOptions } from 'forms/utils/formOptions';

import { proFormaFormFields } from './proFormaFormConfig';
import { ProFormaTable } from './ProFormaTable';
import { useRootStore } from 'stores/RootStore';
import { UnderwritingOutput } from 'types/underwriting/underwriting';

const formConfig: FormOptions = {
  fields: proFormaFormFields,
  options: {
    ...formOptions,
    validateOnChange: true,
  },
  plugins,
};

type ProFormaProps = {
  form: Form;
};

const ProFormaContainer = observer(({ form }: ProFormaProps) => {
  const { underwritingPageStore } = useRootStore();
  const { underwritingData = {} as UnderwritingOutput } = underwritingPageStore;

  return (
    <Grid container>
      <Stack spacing={2} sx={{ width: '100%' }}>
        <Paper key="pro-forma" sx={{ p: 2, mb: 6 }}>
          <Grid container>
            <Grid item xs={12}>
              <Typography variant="h6">Pro Forma</Typography>
              <Grid container xs={12} sx={{ mb: 0 }}>
                <ProFormaTable underwritingData={underwritingData} />
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </Stack>
    </Grid>
  );
});

export default wrapForm(formConfig)(ProFormaContainer);
